// ============================================
// FILE: components/LoadingScreen.tsx
// ============================================
import React from 'react';
import logo from '../assets/images/pitchout_square _logo.png';

export const LoadingScreen: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #d4f17e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative blur circles */}
      <div style={{
        position: 'absolute',
        top: '-100px',
        right: '-100px',
        width: '300px',
        height: '300px',
        background: 'rgba(212, 241, 126, 0.2)',
        borderRadius: '50%',
        filter: 'blur(60px)'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-150px',
        left: '-100px',
        width: '400px',
        height: '400px',
        background: 'rgba(15, 61, 62, 0.3)',
        borderRadius: '50%',
        filter: 'blur(80px)'
      }} />

      <div style={{
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Logo */}
        <img
          src={logo}
          alt="PitchOut"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto 24px',
            animation: 'pulse 2s ease-in-out infinite'
          }}
        />

        {/* App Name */}
        <h1 style={{
          fontSize: '2rem',
          fontWeight: '700',
          color: 'white',
          margin: '0 0 16px 0',
          letterSpacing: '-0.5px'
        }}>
          PitchOut
        </h1>

        {/* Loading Spinner */}
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255, 255, 255, 0.2)',
          borderTop: '4px solid #d4f17e',
          borderRadius: '50%',
          margin: '0 auto',
          animation: 'spin 1s linear infinite'
        }} />

        <p style={{
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '1rem',
          marginTop: '24px'
        }}>
          Loading...
        </p>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.9; }
        }
      `}</style>
    </div>
  );
};